var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedium = function SvgMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.596 3.36H4.32a1.7 1.7 0 0 0-.96 1.04v15.07c.22.679.854 1.17 1.604 1.17h13.987a1.69 1.69 0 0 0 1.688-1.693V4.923a1.69 1.69 0 0 0-1.043-1.564m-3.308 6.332h-.337c-.124 0-.268.163-.268.279v4.185c0 .115.144.288.268.288h.337v.972h-3.014v-.972h.605v-4.396h-.029l-1.487 5.368H11.21l-1.468-5.368h-.03v4.397h.634v.971H7.795v-.972h.326c.134 0 .278-.173.278-.288V9.97c0-.116-.144-.28-.278-.28h-.326v-1.01h3.186l1.046 3.907h.029l1.055-3.906h3.177z"
  })));
};
export default SvgMedium;